import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import Contact from './pages/contact/Contact';
import Footer from './components/Footer';
import './App.css';
import Navbar from './components/Navbar';

import Login from './pages/user/Login';
import Regsiter from './pages/user/Regsiter';

import About from './pages/about/About';

import Career from './pages/career/Career';
import Privacy from './pages/Privacy';
import UserDashboard from './pages/user/UserDashboard';

import ScrollToTop from './pages/TopToBack/ScrollToTop';


import Top from './pages/TopToBack/Top';


import OtpVerification from './pages/user/OtpVerification';
import MyProfile from './pages/user/Myrpofile';
import MyCourse from './pages/user/MyCourse';
import MyJob from './pages/user/MyJob';

import Services from './pages/service/Service';

const App = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />

      <Routes>
        {/* General Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Services />} />

        
        <Route path="/career" element={<Career />} />
           <Route path="/privacyandpolicies" element={<Privacy />} />

        
        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Regsiter />} />
        <Route path="/otpverify" element={<OtpVerification />} />

        {/* User Dashboard */}
        <Route path="/user" element={<UserDashboard />}>
          <Route path="myprofile" element={<MyProfile />} />
          <Route path="myjobs" element={<MyJob />} />
          <Route path="mycourses" element={<MyCourse />} />
        </Route>

      </Routes>

    
      <Top />
      <Footer />
    </>
  );
};

export default App;
